import { Outlet, createFileRoute } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getIncomingPostbackQueryOptions } from "api/TenantSlug/IncomingPostback/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout"
)({
    loader: async ({ params: { id } }) => {
        let breadcrumb = id;

        try {
            const { incomingPostback } = await queryClient.ensureQueryData(
                getIncomingPostbackQueryOptions(id, { filter: { fields: { incoming_postbacks: "name" } } })
            );

            breadcrumb = incomingPostback.name ?? id;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_incoming_postback" />,
    component: () => <Outlet />,
});
